import { useLazyQuery } from "@apollo/client";
import { DefaultInfo } from "components/NothingRight";
import { TableFooter } from "components/Table/Footer";
import useText from "constants/text";
import { Program } from "generated/graphql";
import { ALL_PROGRAMS } from "graphql/Fidelity/queries";
import React, { FC, useEffect, useState } from "react";
import { Loader } from "ui/Loader";
import { isSuccess } from "utils/https";
import Banner from "../components/Banner";
import FidelityItem from "../components/FidelityItem";
import Header from "../components/Header";
import ProgramDetails from "../containers/ProgramDetails";
import { FidelityLayout, useProgramStyles } from "../style";

const ROW_FIDELITY_PER_PAGE_OPTIONS = [8, 16, 24];

const Programs: FC = (props) => {
  const styles = useProgramStyles();
  const { text } = useText();
  const [currentProgram, setCurrentProgram] = useState<Program>(null);
  const [countTotal, setCountTotal] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(8);
  const [page, setPage] = useState<number>(0);

  const [progams, setPrograms] = useState<Program[]>([]);
  const [allPrograms, allProgramData] = useLazyQuery(ALL_PROGRAMS);
  useEffect(() => {
    allPrograms({
      variables: {
        queries: {
          limit: rowsPerPage,
          page: page + 1,
        },
      },
    });
  }, [page, rowsPerPage]);

  useEffect(() => {
    if (isSuccess(allProgramData?.data)) {
      setPrograms(allProgramData?.data?.results?.data);
      setCountTotal(allProgramData?.data?.results?.countTotal);
    }
  }, [allProgramData]);
  const handleSelectItem = (program: Program) => {
    setCurrentProgram(program);
  };
  const onChangPage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const onChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
  };
  return (
    <FidelityLayout>
      <div className="container">
        <div className="left">
          <Header />
          <div className="card-container">
            <Banner title={text.fidelity_program.fidelity_program_title} />
            <div className={styles.container}>
              {allProgramData.loading && <Loader size={40} margin="300px" />}
              {!allProgramData.loading &&
                progams?.map((program: Program, index: number) => (
                  <FidelityItem onSelectItem={handleSelectItem} key={index} program={program} />
                ))}
            </div>
            {countTotal > ROW_FIDELITY_PER_PAGE_OPTIONS[0] && (
              <TableFooter
                rowsPerPageOptions={ROW_FIDELITY_PER_PAGE_OPTIONS}
                handleChangePage={onChangPage}
                count={countTotal}
                handleChangeRowsPerPage={onChangeRowsPerPage}
                page={page}
                rowsPerPage={rowsPerPage}
              />
            )}
          </div>
        </div>
        <div className="right">{currentProgram ? <ProgramDetails program={currentProgram} /> : <DefaultInfo />}</div>
      </div>
    </FidelityLayout>
  );
};

export default Programs;
